import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../app/store";
import { Paths } from "../router/Paths";

export default function useLoggedIn() {
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.user);

  useEffect(() => {
    if (user) {
      const currentLink = window.location.pathname;
      if (currentLink.includes(Paths.login)) {
        navigate(Paths.home);
      } else {
      }
    }
  }, [user]);

  return undefined;
}
